import {
  ACTIVITIES_RESPONSE_VARIANT_TEXT,
  ACTIVITIES_RESPONSE_VARIANT_TEXT_IMAGE,
  COMPONENT_LAYOUT_LIST,
  LANGUAGE_CODE_EN_AU,
} from 'global/constants';
import { MultipleChoiceOption } from './multiple-choice.constants';
import { ComponentMultipleChoice } from '../component.constants';
import MultipleChoiceEditList from './list/multiple-choice-edit-list';
import MultipleChoiceEditTextImage from './text-image/multiple-choice-edit-text-image';
import MultipleChoiceEditImage from './image/multiple-choice-edit-image';
import MultipleChoiceEditText from './text/multiple-choice-edit-text';

type Props = {
  index: number;
  isUpdating: boolean;
  isOneOptionCorrect: boolean;
  option: MultipleChoiceOption;
  setIsUpdating: (state: boolean) => void;
};

const MultipleChoiceEditOption = ({
  properties,
  subActivityProperties,
  suggestedAnswerProperties,
  sectionId,
  id,
  type,
  sort,
  index,
  isUpdating,
  isOneOptionCorrect,
  option,
  setIsUpdating,
  version,
}: Props & Omit<ComponentMultipleChoice, '__typename'>) => {
  const isList = properties.layout?.display === COMPONENT_LAYOUT_LIST;
  const isText =
    properties.multipleChoice.variant === ACTIVITIES_RESPONSE_VARIANT_TEXT;
  const isTextAndImage =
    properties.multipleChoice.variant ===
    ACTIVITIES_RESPONSE_VARIANT_TEXT_IMAGE;

  if (isText && isList) {
    return (
      <MultipleChoiceEditList
        id={id}
        index={index}
        isOneOptionCorrect={isOneOptionCorrect}
        option={option}
        properties={properties}
        sectionId={sectionId}
        sort={sort}
        type={type}
        subActivityProperties={subActivityProperties}
        suggestedAnswerProperties={suggestedAnswerProperties}
        language={LANGUAGE_CODE_EN_AU}
        version={version}
      />
    );
  }

  return isTextAndImage ? (
    <MultipleChoiceEditTextImage
      id={id}
      index={index}
      option={option}
      properties={properties}
      sectionId={sectionId}
      sort={sort}
      type={type}
      subActivityProperties={subActivityProperties}
      suggestedAnswerProperties={suggestedAnswerProperties}
      isUpdating={isUpdating}
      setIsUpdating={setIsUpdating}
      language={LANGUAGE_CODE_EN_AU}
      version={version}
    />
  ) : isText ? (
    <MultipleChoiceEditText
      id={id}
      index={index}
      option={option}
      properties={properties}
      sectionId={sectionId}
      sort={sort}
      type={type}
      subActivityProperties={subActivityProperties}
      suggestedAnswerProperties={suggestedAnswerProperties}
      language={LANGUAGE_CODE_EN_AU}
      version={version}
    />
  ) : (
    <MultipleChoiceEditImage
      id={id}
      index={index}
      isUpdating={isUpdating}
      option={option}
      properties={properties}
      sectionId={sectionId}
      setIsUpdating={setIsUpdating}
      sort={sort}
      subActivityProperties={subActivityProperties}
      suggestedAnswerProperties={suggestedAnswerProperties}
      type={type}
      language={LANGUAGE_CODE_EN_AU}
      version={version}
    />
  );
};

export default MultipleChoiceEditOption;
